export enum HomePageTypes {
  Home = 'Home',
  Mobiliar = 'Mobiliar',
}

export const HomePageTypeKey = 'homePageType'
